// esico.online
// export const apiurl = "https://esico.online/backend/api/";
// export const mediaurl = "https://esico.online/backend/media/";

// esicoksa.com
export const apiurl = "https://esicoksa.com/backend/api/";
export const mediaurl = "https://esicoksa.com/backend/media/";
export const backendurl = "https://esicoksa.com/backend/";